import { render, staticRenderFns } from "./pharmacistManage.vue?vue&type=template&id=2184b3d2&scoped=true&"
import script from "./pharmacistManage.vue?vue&type=script&lang=js&"
export * from "./pharmacistManage.vue?vue&type=script&lang=js&"
import style0 from "./pharmacistManage.vue?vue&type=style&index=0&id=2184b3d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184b3d2",
  null
  
)

export default component.exports